import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// PWA do Coletor: registra o service worker de public/sw.js (regra de ouro lá
// dentro — HTML e API sempre pela rede; o cache é só a casca do app).
//
// Só em produção: com o dev server o SW ficaria servindo bundle antigo entre
// recompilações. Exige HTTPS ou localhost — o navegador ignora em HTTP puro,
// que é o caso do IP cru; por isso o galpão acessa pelo domínio.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/sw.js`).catch(() => {
            // App sem PWA continua funcionando: falhar aqui não pode derrubar a tela.
        });
    });
}
